export const LEGACY_OWNERSHIP_ACTION_PREFIX = 'LEGACY_OWNERSHIP/';
